/**
 * Constantes para el módulo de Concesionarias
 */

// Estados de perfiles de vehículos
export const ESTADO_PERFIL_VEHICULO = {
  PRE_CREADO: 'pre_creado',           // Perfil creado pero sin asignar
  ASIGNADO: 'asignado',               // Asignado a cliente pero no activo aún
  PENDIENTE_VALIDACION: 'pendiente_validacion', // Credenciales asignadas, pendiente validación por concesionaria
  ACTIVO: 'activo',                   // Activo con membresía premium (validado)
  EXPIRADO: 'expirado'                // Membresía expirada (pasa a básico)
};

// Tipos de vehículos
export const TIPO_VEHICULO = {
  SEDAN: 'sedan',
  HATCHBACK: 'hatchback',
  SUV: 'suv',
  PICKUP: 'pickup',
  VAN: 'van',
  COUPE: 'coupe',
  CONVERTIBLE: 'convertible',
  ESTACION_WAGON: 'estacion_wagon',
  OTRO: 'otro'
};

// Duración de membresía premium para vehículos de concesionaria
export const DURACION_MEMBRESIA_PREMIUM_MESES = 12;

// Configuración de lotes
export const TAMANOS_LOTES = {
  LOTE_50: { cantidad: 50, nombre: 'Lote 50 perfiles' },
  LOTE_100: { cantidad: 100, nombre: 'Lote 100 perfiles' },
  LOTE_200: { cantidad: 200, nombre: 'Lote 200 perfiles' },
  PERSONALIZADO: { cantidad: 0, nombre: 'Lote personalizado' }
};

// Descripciones de estados
export const DESCRIPCION_ESTADO_PERFIL = {
  [ESTADO_PERFIL_VEHICULO.PRE_CREADO]: 'Perfil creado, esperando asignación',
  [ESTADO_PERFIL_VEHICULO.ASIGNADO]: 'Asignado a cliente, membresía pendiente de activación',
  [ESTADO_PERFIL_VEHICULO.PENDIENTE_VALIDACION]: 'Credenciales asignadas, pendiente validación por concesionaria',
  [ESTADO_PERFIL_VEHICULO.ACTIVO]: 'Activo con membresía premium (12 meses) - Validado',
  [ESTADO_PERFIL_VEHICULO.EXPIRADO]: 'Membresía expirada, perfil en modo básico'
};

// Colores para estados (Tailwind)
export const COLOR_ESTADO_PERFIL = {
  [ESTADO_PERFIL_VEHICULO.PRE_CREADO]: 'bg-gray-100 text-gray-800',
  [ESTADO_PERFIL_VEHICULO.ASIGNADO]: 'bg-yellow-100 text-yellow-800',
  [ESTADO_PERFIL_VEHICULO.PENDIENTE_VALIDACION]: 'bg-orange-100 text-orange-800',
  [ESTADO_PERFIL_VEHICULO.ACTIVO]: 'bg-green-100 text-green-800',
  [ESTADO_PERFIL_VEHICULO.EXPIRADO]: 'bg-red-100 text-red-800'
};

// Iconos para estados
export const ICONO_ESTADO_PERFIL = {
  [ESTADO_PERFIL_VEHICULO.PRE_CREADO]: '📝',
  [ESTADO_PERFIL_VEHICULO.ASIGNADO]: '⏳',
  [ESTADO_PERFIL_VEHICULO.PENDIENTE_VALIDACION]: '🔍',
  [ESTADO_PERFIL_VEHICULO.ACTIVO]: '✅',
  [ESTADO_PERFIL_VEHICULO.EXPIRADO]: '⏰'
};


